// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"i1QE3lhGj4veMlNUjduut"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/PageBasic.scss
// module id = 690
// module chunks = 0